import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import Clickable from '@prisjakt/ui-clickable';

export const WordCloudContainer = styled.ul`
  background: ${props => props.theme.bg.secondary};
  padding: ${layout.spacing.large} ${layout.spacing.small};
  margin: 0 ${layout.pageContent.gutter.rem};
  margin-bottom: ${layout.spacing.large};
  ${media.mediumDown`
    margin: 0;
    margin-bottom: ${layout.spacing.medium};
    padding: ${layout.spacing.medium} ${layout.pageContent.gutter.rem};
  `}
`;

export const WordCloudList = styled.ul`
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  margin: -5px;
  padding: ${layout.spacing.medium} 0;
  ${media.mediumDown`
    padding: ${layout.spacing.small} 0;
  `}
`;

export const WordCloudItem = styled.li`
  flex: 0;
  max-width: 250px;
  margin: 5px;
`;

export const WordCloudLink = styled(Clickable)`
  background-color: ${({ theme }) => theme.bg.primary};
  border-radius: 4px;
  font-weight: 600;
  display: inline-flex;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 6px 10px;
  font-size: ${layout.measurements.fontSizeSmall};
  transition: color ${layout.animations.buttonTransition};
  color: ${({ theme }) => theme.buttons.link.text};
  &:hover {
    color: ${({ theme }) => theme.buttons.link.textHover};
  }
`;
